import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { empty, Observable, of } from 'rxjs';
import { AlertController } from '@ionic/angular';
import { LoadingService } from '../../alerts/loading/loading.service';
import { laravelErrorExtract } from '../laravel-error-extract/laravel-error-extract';

/** HandleError Type  */
export type HandleError = <T>(
  operation?: string,
  result?: T
) => (error: HttpErrorResponse) => Observable<T>;

@Injectable()
export class HttpErrorHandler {
  constructor(
    private alertController: AlertController,
    private loadingService: LoadingService
  ) {}

  /** Pass the service name to map errors */
  createHandleError =
    (serviceName = '') =>
    <T>(operation = 'operation', result = {} as T) =>
      this.handleError(serviceName, operation, result);

  handleError<T>(serviceName = '', operation = 'operation', result = {} as T) {
    return (response: HttpErrorResponse): Observable<T> => {
      // Show validation error
      if (response.status === 422) {
        // Extract form error messages from API
        const messages = laravelErrorExtract(response);
        console.log(messages);
        this.showValidationErrorsAlert(messages);
        // Show authorization error
      } else if (response.status === 401) {
        this.showAuthorizationErrorsAlert(
          response.error.message
            ? response.error.message
            : JSON.stringify(response.error)
        );
        // Show authentication error
      } else if (response.status === 403) {
        this.showAuthorizationErrorsAlert(
          response.error.message
            ? response.error.message
            : JSON.stringify(response.error)
        );
      } else {
        // Optionally send the error to a third part error logging service
        // console.error(response);
        console.log(response);

        // Show a simple alert if error
        let message;
        if (response instanceof HttpErrorResponse) {
          message =
            response.error instanceof ErrorEvent
              ? response.error.message
              : `Kod błedu: ${response.status}<br> Wiadomość: ${
                  response.error.message
                    ? response.error.message
                    : JSON.stringify(response.error)
                }`;
        }

        if (response.status === 0) {
          if (confirm('Brak połączenia z siecią. Spróbuj ponownie.')) {
            window.location.reload();
          } else {
            window.location.reload();
          }
        }

        this.presentAlert(message ? message : response);
      }

      // Keep running and returning a safe result.
      // return of(result);

      // Return empty to stop subscribe methods
      return empty();
    };
  }

  async presentAlert(messageText: any) {
    const alert = await this.alertController.create({
      header: 'Błąd',
      message:
        'Wystąpił błąd po stronie serwera.<br><br>Komunikat błedu:<br><i>' +
        messageText +
        '</i>',
      cssClass: 'ma-alert--md',
      buttons: [
        {
          // text: 'Spróbuj ponownie',
          text: 'Zamknij',
          handler: () => {
            // window.location.reload();
          },
        },
      ],
    });

    this.loadingService.closeLoadingAlert();
    await alert.present();
  }

  async showValidationErrorsAlert(messages: string[]) {
    const list = messages.map((message) => '<li>' + message + '</li>');
    const aa = list.filter((item) => item !== undefined);
    console.log(aa);

    const alert = await this.alertController.create({
      header: 'Błąd walidacji',
      message: '<ul>' + list.filter((item) => item).join('') + '</ul>',
      cssClass: ['pxc-alert--validation', 'ma-alert--md'],
      buttons: [
        {
          text: 'Zamknij',
        },
      ],
    });

    this.loadingService.closeLoadingAlert();
    await alert.present();
  }

  async showAuthorizationErrorsAlert(message: string) {
    const alert = await this.alertController.create({
      header: 'Błąd autoryzacji',
      message: message,
      cssClass: 'ma-alert--md',
      buttons: [
        {
          text: 'Zamknij',
        },
      ],
    });

    this.loadingService.closeLoadingAlert();
    await alert.present();
  }
}
